
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

const WhatsAppButton = () => {
  const [showMessage, setShowMessage] = useState(false);
  const [showTyping, setShowTyping] = useState(false);

  useEffect(() => {
    // Mostrar animação de digitação após 2 segundos
    const typingTimer = setTimeout(() => {
      setShowTyping(true);
    }, 2000);

    // Mostrar mensagem após 5 segundos (2s + 3s de digitação)
    const messageTimer = setTimeout(() => {
      setShowTyping(false);
      setShowMessage(true);
    }, 5000);

    // Esconder mensagem após 10 segundos
    const hideTimer = setTimeout(() => {
      setShowMessage(false);
    }, 15000);

    return () => {
      clearTimeout(typingTimer);
      clearTimeout(messageTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Mensagem de texto */}
      {showMessage && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.8 }}
          className="absolute bottom-20 right-0 mb-2 mr-2"
        >
          <div className="bg-white rounded-2xl shadow-xl p-4 max-w-64 relative">
            <p className="text-gray-800 text-sm font-medium">
              Olá, tudo bem? Como podemos lhe ajudar?
            </p>
            {/* Seta apontando para o botão */}
            <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white transform rotate-45 shadow-lg"></div>
          </div>
        </motion.div>
      )}

      {/* Animação de digitação */}
      {showTyping && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.8 }}
          className="absolute bottom-20 right-0 mb-2 mr-2"
        >
          <div className="bg-white rounded-2xl shadow-xl p-4 relative">
            <div className="flex items-center space-x-1">
              <div className="flex space-x-1">
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
              </div>
            </div>
            {/* Seta apontando para o botão */}
            <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white transform rotate-45 shadow-lg"></div>
          </div>
        </motion.div>
      )}

      {/* Botão do WhatsApp */}
      <motion.a
        href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa."
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring' }}
        className="w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform cursor-pointer"
        style={{
          animation: 'pulse 2s infinite',
        }}
        onClick={() => setShowMessage(false)}
      >
        <i className="ri-whatsapp-fill text-white text-3xl"></i>
        <style>{`
          @keyframes pulse {
            0%, 100% {
              box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
            }
            50% {
              box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
            }
          }
        `}</style>
      </motion.a>
    </div>
  );
};

export default WhatsAppButton;
